var map = {
	"./1.svg": 80304,
	"./2.svg": 37347,
	"./3.svg": 22706,
	"./4.svg": 56637,
	"./5.svg": 67164,
	"./6.svg": 46191,
	"./7.svg": 2462,
	"./8.svg": 44985,
	"./9.svg": 79592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18403;